import { render } from "./ElementosGastosList.vue?vue&type=template&id=02b6598d"
import script from "./ElementosGastosList.vue?vue&type=script&lang=js"
export * from "./ElementosGastosList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__